import { useForm } from '@conform-to/react'
import { parseWithZod } from '@conform-to/zod'
import { useFetcher, useNavigation } from '@remix-run/react'
import { useTranslation } from 'react-i18next'
import { getFetcherType } from 'remix-utils/fetcher-type'
import {
	CREATE_ADDRESS_FORM,
	CREATE_ADDRESS_INPUTS,
	createAddressSchema,
} from '#app/components/forms/create-address-form/create-address-form.tsx'
import { PROFILE_ADDRESSES_CREATE_I18NEXT } from '#app/routes/($lang).profile.addresses.create/route-config'
import { ROOT_INPUTS } from '#app/routes/_layout/route-config.ts'

function useCreateAddressForm() {
	const { t } = useTranslation(
		PROFILE_ADDRESSES_CREATE_I18NEXT.routeProfileAddressesCreate,
	)

	const fetcherKey = CREATE_ADDRESS_FORM.subaction
	const fetcher = useFetcher({ key: fetcherKey })

	const formValues = {
		[ROOT_INPUTS.subaction]: CREATE_ADDRESS_FORM.subaction,
		[ROOT_INPUTS.noJs]: 'true',
	}
	const [form, fields] = useForm({
		lastResult: fetcher.data || undefined,
		defaultValue: {
			[CREATE_ADDRESS_INPUTS.countryCode]: 'DE',
		},
		onValidate({ formData }) {
			return parseWithZod(formData, { schema: createAddressSchema })
		},
		shouldValidate: 'onBlur',
	})

	const fetcherType = getFetcherType(fetcher, useNavigation())

	return {
		createAddressFetcherKey: fetcherKey,
		createAddressFetcher: fetcher,
		createAddressFormValues: formValues,
		createAddressForm: form,
		createAddressFields: fields,
		createAddressFetcherType: fetcherType,
		t,
	}
}

export { useCreateAddressForm }
